import React, { useState } from "react";
import axios from "axios";
import { useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import { API_PROVEEDORES_URL } from "../../constants";

import './css/ProveedoresCatalogo.css'
import { toast } from 'react-toastify';

import { Col, Form, Card } from "react-bootstrap";

import NumberFormat from 'react-number-format';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory, { PaginationProvider, PaginationTotalStandalone, PaginationListStandalone, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';
import { Check, ChevronLeft, ChevronRight, PersonBadge, GeoAlt, CashStack } from "react-bootstrap-icons";
import InputGroup from 'react-bootstrap/InputGroup';
import { faMagnifyingGlass, faRotateLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const SECCIONES = ['general', 'direccion', 'bancarios'];

const SECCION_INFO = {
    general: { label: 'Información general', Icono: PersonBadge, color: '#4FD290' },
    direccion: { label: 'Dirección', Icono: GeoAlt, color: '#FD9558' },
    bancarios: { label: 'Datos bancarios', Icono: CashStack, color: '#1CBBC1' },
};

function FormularioNuevoProveedor() {
    const [deactivate, setDeactivate] = useState(false);
    const [status, setStatus] = useState(false);
    const [request] = useState(false);
    const empresasDisponibles = useSelector(state => state.empresas.empresasDisponibles);

    const [seccionActiva, setSeccionActiva] = useState('general');

    const [dataBank, setDataBank] = useState([]);
    const [idProveedor, setIdProveedor] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [isFiscal, setIsFiscal] = useState(false);
    const [isSucursal, setIsSucursal] = useState(false);
    const [isBodega, setIsBodega] = useState(false);
    const [returnToActivate, setReturnToActivate] = useState(false);
    const [colonias, setColonias] = useState([]);
    const [isSearch, setIsSearch] = useState(false);
    const [errorCPMessage, setErrorCPMessage] = useState('');
    const [proveedorRfc, setProveedorRfc] = useState('');
    const [razonSocial, setRazonSocial] = useState('');
    const [nombreComercial, setNombreComercial] = useState('');
    const [correoElectronico, setCorreoElectronico] = useState('');
    const [telefono, setTelefono] = useState('');
    const [giro, setGiro] = useState('');
    const [tipo, setTipo] = useState('');
    const [calle, setCalle] = useState('');
    const [numeroExterior, setNumeroExterior] = useState('');
    const [numeroInterior, setNumeroInterior] = useState('');
    const [colonia, setColonia] = useState('');
    const [ciudad, setCiudad] = useState('');
    const [codigoPostal, setCodigoPostal] = useState('');
    const [municipio, setMunicipio] = useState('');
    const [estado, setEstado] = useState('');
    const [pais, setPais] = useState('');

    const [banco, setBanco] = useState('');
    const [comentario, setComentario] = useState('');
    const [cuenta, setCuenta] = useState('');
    const [cuentaClabe, setCuentaClabe] = useState('');
    const [referencia, setReferencia] = useState('');
    const [empresa, setEmpresa] = useState([]);

    const [idEmpresasSeleccionadas, setIdEmpresasSeleccionadas] = useState([]);
    const [empresasSeleccionadas, setEmpresasSeleccionadas] = useState([]);
    const errorEmpresas = false;

    const [active, setActive] = useState(false);

    let history = useHistory();
    const redirectPage = () => {
        history.push('/proveedores/lista', 1000);
    };

    function handleProveedorRfcChange(e) {
        setProveedorRfc(e.target.value);
    }
    function handleNombreComercialChange(e) {
        setNombreComercial(e.target.value);
    }
    function handleRazonSocialChange(e) {
        setRazonSocial(e.target.value);
    }
    function handleCorreoElectronicoChange(e) {
        setCorreoElectronico(e.target.value);
    }
    function handleTelefonoChange(e) {
        setTelefono(e.target.value);
    }
    function handleGiroChange(e) {
        setGiro(e.target.value);
    }
    function handleBancoChange(e) {
        setBanco(e.target.value);
    }
    function handleComentarioChange(e) {
        setComentario(e.target.value);
    }
    function handleCuentaChange(e) {
        setCuenta(e.target.value);
    }
    function handleCuentaClabeChange(e) {
        setCuentaClabe(e.target.value);
    }
    function handleReferenciaChange(e) {
        setReferencia(e.target.value);
    }
    function handleTipoChange(e) {
        setTipo(e.target.value);
    }
    function handleCalleChange(e) {
        setCalle(e.target.value);
    }
    function handleNumeroExteriorChange(e) {
        setNumeroExterior(e.target.value);
    }
    function handleNumeroInteriorChange(e) {
        setNumeroInterior(e.target.value);
    }
    function handlerColoniaChange(e) {
        setColonia(e.target.value);
    }
    function handleCiudadChange(e) {
        setCiudad(e.target.value);
    }
    function handleCodigoPostalChange(e) {
        setCodigoPostal(e.target.value);
    }
    function handleMunicipioChange(e) {
        setMunicipio(e.target.value);
    }
    function handleEstadoChange(e) {
        setEstado(e.target.value);
    }
    function handlePaisChange(e) {
        setPais(e.target.value);
    }

    function handleKeyPress(e) {
        if (e.key === 'Enter') {
            searchCP();
        }
    }

    function searchCP() {
        axios.post("https://dev.hixsa.net/API-DIRECCIONES/api/direccion", {
            codigoPostal: codigoPostal,
        }).then(res => {
            if ((res.data.respuesta.estados).length !== 0) {
                console.log(console.log(res.data.respuesta));

                setErrorCPMessage('');
                setIsSearch(true);
                setCalle(calle);
                setNumeroExterior(numeroExterior);
                setNumeroInterior(numeroInterior);
                setCodigoPostal(codigoPostal);
                setCiudad(res.data.respuesta.estados[0].descripcion);
                setMunicipio(res.data.respuesta.municipios[0].descripcion);
                setColonias(res.data.respuesta.colonias);
                setEstado(res.data.respuesta.estados[0].descripcion);
                setPais('México');
            } else {
                setErrorCPMessage('CP sin registros');
            }
            console.log(res);
        }).catch(err => {
            setErrorCPMessage('CP sin registros');
        });
    }

    function deleteDataBankFields() {
        setComentario('');
        setCuenta('');
        setCuentaClabe('');
        setReferencia('');
    }

    function setDataAccount(e) {
        if (e.target.value !== '-1') {
            if (e.target.value == "otro") {
                setActive(false);
                setReturnToActivate(true);

                deleteDataBankFields();
            }
            else {
                let ind = parseInt(e.target.value);
                let index = dataBank.findIndex(x => x.id === ind);

                console.log(dataBank[index]);

                setBanco(dataBank[index].banco);
                setComentario(dataBank[index].comentario);
                setCuenta(dataBank[index].cuenta);
                setCuentaClabe(dataBank[index].cuentaClabe);
                setReferencia(dataBank[index].referencia);
            }
        } else {
            deleteDataBankFields();
        }
    }

    function validateBankDetails() {
        if (banco === '') {
            setDeactivate(true);
            setTimeout(() => {
                setDeactivate(false);
            }, 4500);

            toast.error('El campo "Banco" es obligatorio, por favor ingrese la información correspondiente antes de registrar', {
                position: "top-center",
                autoClose: 4500,
            });
        }

        else if (banco !== '') {
            if (cuenta !== '' || cuentaClabe !== '') {
                insertProveedor();
            }
            else if (cuenta === '') {
                setDeactivate(true);
                setTimeout(() => {
                    setDeactivate(false);
                }, 5000);

                toast.error('Para poder registrar al proveedor, debe completar el campo "Cuenta" o "Cuenta Clabe" de los Datos Bancarios', {
                    position: "top-center",
                    autoClose: 5000,
                });
            }
        }
    }

    function insertProveedor() {
        setStatus(true);

        if (empresasSeleccionadas.length && proveedorRfc.length && razonSocial.length) {
            axios.post(API_PROVEEDORES_URL + 'insertProveedor',
                {
                    empresa: empresasSeleccionadas,
                    idEmpresa: idEmpresasSeleccionadas,
                    nombreComercial: nombreComercial,
                    razonSocial: razonSocial,
                    proveedorRfc: proveedorRfc,
                    correoElectronico: correoElectronico,
                    telefono: telefono,
                    giro: giro,
                    banco: banco,
                    cuenta: cuenta,
                    cuentaClabe: cuentaClabe,
                    comentario: comentario,
                    referencia: referencia,
                    tipo: tipo,
                    calle: calle,
                    numeroExterior: numeroExterior,
                    numeroInterior: numeroInterior,
                    colonia: colonia,
                    ciudad: ciudad,
                    codigoPostal: codigoPostal,
                    municipio: municipio,
                    estado: estado,
                    pais: pais
                }
            ).then((res) => {
                if (res.data.result.success) {
                    setStatus(false);
                    toast.success(res.data.result.message, {
                        position: "top-center",
                        autoClose: 4500,
                    });
                    redirectPage()
                } else {
                    let output = [];
                    setStatus(false);
                    toast.error(res.data.result.message, {
                        position: "top-center",
                        autoClose: 4500,
                    });
                    toast.error(res.data.result.suggestion, {
                        position: "top-center",
                        autoClose: 4500,
                    });
                    output.push('<strong>', "Empresas correctas: " + res.data.correctos, '</strong>');
                    output.push('<strong>', "Empresas incorrectas: " + res.data.errores, '</strong>');
                    res.data.registros_con_errores.forEach(incorrecto => {
                        output.push('<li><strong>', incorrecto.message, '</strong> (', incorrecto.suggestion, ')');
                    });
                    document.getElementById("listResponse").innerHTML = '<ol>' + output.join('') + '</ol>';
                }
            }).catch((error) => {
                console.log(error)
                toast.error("No se ha podido registrar el proveedor", {
                    position: "top-center",
                    autoClose: 4500,
                });
                setStatus(false);
            });
        } else {
            setDeactivate(true);

            setTimeout(() => {
                setDeactivate(false);
            }, 4500);

            !empresasSeleccionadas.length ?
                toast.warning("Debes seleccionar al menos una empresa", {
                    position: "top-center",
                    autoClose: 4500,
                })
                : !proveedorRfc.length ?
                    toast.warning("El campo 'RFC' no puede estar vacío", {
                        position: "top-center",
                        autoClose: 4500,
                    })
                    :
                    toast.warning("El campo 'Razón social' no puede estar vacío", {
                        position: "top-center",
                        autoClose: 4500,
                    })
            setStatus(false);
        }
    }

    function changeToSelect() {
        setReturnToActivate(false);
        setActive(true);
    }

    function removeDataField() {
        setIdProveedor('');
        setRazonSocial('');
        setNombreComercial('');
        setGiro('');
        setCorreoElectronico('');
        setTelefono('');

        setIsFiscal(false);
        setIsSucursal(false);
        setIsBodega(false);
        setTipo('');
        setCalle('');
        setNumeroExterior('');
        setNumeroInterior('');
        setColonia('');
        setCiudad('');
        setCodigoPostal('');
        setMunicipio('');
        setEstado('');
        setPais('');

        setActive(false);
        setBanco('');
        setComentario('');
        setCuenta('');
        setCuentaClabe('');
        setReferencia('');
    }

    function searchDataBankSupplier(proveedorId) {
        axios.post(API_PROVEEDORES_URL + 'listBancoCuentas', {
            idProveedor: proveedorId
        }).then((res) => {
            if (res.data.result.code === 200) {
                setDataBank(res.data.cuentasBancarias[0].lista);
                setActive(true);
            } else {
                setErrorMessage('El proveedor no cuenta con datos bancarios');
            }
        }).catch((error) => {
            setErrorMessage('Error en el servidor, intente mas tarde');
        }).finally(() => {
            console.log('Fin de busqueda de datos bancarios del RFC proveedor');
        })
    }

    function searchAddressSupplier(proveedorId) {
        axios.post(API_PROVEEDORES_URL + 'listDirecciones', {
            idProveedor: proveedorId
        }).then((res) => {
            if (res.data.result.code === 200) {
                if (res.data.listDireccion[0].tipo == 'Fiscal') { setIsFiscal(true) }
                if (res.data.listDireccion[0].tipo == 'Sucursal') { setIsSucursal(true) }
                if (res.data.listDireccion[0].tipo == 'Bodega') { setIsBodega(true) }

                setCalle(res.data.listDireccion[0].calle);
                setNumeroExterior(res.data.listDireccion[0].numeroExterior);
                setNumeroInterior(res.data.listDireccion[0].numeroInterior);
                setColonia(res.data.listDireccion[0].colonia);
                setCiudad(res.data.listDireccion[0].ciudad);
                setCodigoPostal(res.data.listDireccion[0].codigoPostal);
                setMunicipio(res.data.listDireccion[0].municipio);
                setEstado(res.data.listDireccion[0].estado);
                setPais(res.data.listDireccion[0].pais);
            } else {
                setErrorMessage('El proveedor no cuenta con datos datos de dirección');
            }
        }).catch((error) => {
            setErrorMessage('Error en el servidor, intente mas tarde');
        }).finally(() => {
            searchDataBankSupplier(proveedorId);
            console.log('Fin de busqueda de direccion de proveedor por RFC');
        })
    }

    function setArrayEmpresas(supplierList) {
        const aux = [];

        for (let i = 0; i < supplierList.length; i++) {
            aux.push(supplierList[i].empresa);
        }
        setEmpresa(aux);
    }


    function searchSupplier() {
        axios.post(API_PROVEEDORES_URL + 'getProveedorByRfc', {
            rfc: proveedorRfc
        }).then((res) => {
            if (res.data.result.code === 200) {
                console.log('--->');
                console.log(res.data);

                setArrayEmpresas(res.data.listProvId);
                console.log(res.data.listProvId)

                setIdProveedor(res.data.listProvId[0].hashMapCuentaBancaria.idProveedor);
                setRazonSocial(res.data.listProvId[0].razonSocial);
                setNombreComercial(res.data.listProvId[0].nombreComercial);
                setGiro(res.data.listProvId[0].hashMapCuentaBancaria.giro);
                setCorreoElectronico(res.data.listProvId[0].hashMapCuentaBancaria.correoElectronico);
                setTelefono(res.data.listProvId[0].hashMapCuentaBancaria.telefono);

                setErrorMessage('');
                searchAddressSupplier(res.data.listProvId[0].hashMapCuentaBancaria.idProveedor);
            } else {
                removeDataField();
                setErrorMessage('Sin coincidencias');
            }
        }).catch((error) => {
            console.log('Problema en servidor intente');
            setErrorMessage('Error en el servidor, intente mas tarde');
        }).finally(() => {
            console.log('Fin de Busqueda de proveedor por RFC');
        })
    }



    function enterpriseSelected(empresaSelected) {
        toast.warning('La empresa "' + empresaSelected + '" ya cuenta con este proveedor dado de alta, selecccione otro por favor', {
            position: "top-center",
            autoClose: 5000,
        })
    }

    function enterpriseValidation(empresaSelected) {
        let repeated = false;
        for (let i = 0; i < empresa.length; i++) {
            if (empresa[i] === empresaSelected) {
                repeated = true;
                break;
            }
        }

        return repeated;
    }

    function validarSeccionGeneral() {
        if (!empresasSeleccionadas.length) {
            toast.warning("Debes seleccionar al menos una empresa antes de continuar", {
                position: "top-center",
                autoClose: 4000,
            });
            return false;
        }
        if (!proveedorRfc.trim() || !razonSocial.trim() || !nombreComercial.trim() || !correoElectronico.trim() || !telefono.trim()) {
            toast.warning("Completa RFC, razón social, nombre comercial, correo y teléfono antes de continuar", {
                position: "top-center",
                autoClose: 4000,
            });
            return false;
        }
        return true;
    }

    function validarSeccionDireccion() {
        if (!calle.trim() || !numeroExterior.trim() || !codigoPostal.trim() || !ciudad.trim() || !municipio.trim() || !colonia.trim() || !estado.trim() || !pais.trim()) {
            toast.warning("Completa todos los campos de dirección antes de continuar", {
                position: "top-center",
                autoClose: 4000,
            });
            return false;
        }
        return true;
    }

    function validarSeccionActiva() {
        if (seccionActiva === 'general') {
            return validarSeccionGeneral();
        }
        if (seccionActiva === 'direccion') {
            return validarSeccionDireccion();
        }
        return true;
    }

    function irSeccionSiguiente() {
        if (!validarSeccionActiva()) {
            return;
        }
        const idx = SECCIONES.indexOf(seccionActiva);
        if (idx < SECCIONES.length - 1) {
            setSeccionActiva(SECCIONES[idx + 1]);
        }
    }

    function irSeccionAnterior() {
        const idx = SECCIONES.indexOf(seccionActiva);
        if (idx > 0) {
            setSeccionActiva(SECCIONES[idx - 1]);
        }
    }

    function irASeccion(destino) {
        const idxActual = SECCIONES.indexOf(seccionActiva);
        const idxDestino = SECCIONES.indexOf(destino);

        if (idxDestino <= idxActual) {
            setSeccionActiva(destino);
            return;
        }

        if (!validarSeccionActiva()) {
            return;
        }

        setSeccionActiva(destino);
    }

    function renderStepper() {
        const indiceActivo = SECCIONES.indexOf(seccionActiva);
        return (
            <div className="stepper-secciones">
                {SECCIONES.map((sec, idx) => {
                    const info = SECCION_INFO[sec];
                    const Icono = info.Icono;
                    const esActivo = sec === seccionActiva;
                    const esCompleto = idx < indiceActivo;
                    return (
                        <React.Fragment key={sec}>
                            <button
                                type="button"
                                className={`stepper-paso ${esActivo ? 'stepper-paso-activo' : ''} ${esCompleto ? 'stepper-paso-completo' : ''}`}
                                style={{ '--color-seccion': info.color }}
                                onClick={() => irASeccion(sec)}
                            >
                                <span className="stepper-circulo">
                                    {esCompleto ? <Check /> : <Icono />}
                                </span>
                                <span className="stepper-etiqueta">{info.label}</span>
                            </button>
                            {idx < SECCIONES.length - 1 &&
                                <span className={`stepper-linea ${esCompleto ? 'stepper-linea-completa' : ''}`}></span>
                            }
                        </React.Fragment>
                    );
                })}
            </div>
        );
    }

    function renderFooter() {
        const mostrarAnterior = seccionActiva !== 'general';
        const esUltimaSeccion = seccionActiva === 'bancarios';

        return (
            <Card.Footer className="d-flex justify-content-end bg-transparent footer-nuevo-proveedor">
                <div className="footer-derecha">
                    {mostrarAnterior &&
                        <button
                            type="button"
                            className="m-1 btn-anterior"
                            onClick={irSeccionAnterior}
                        ><ChevronLeft className="mr-1" /> Anterior
                        </button>
                    }

                    <button
                        type="button"
                        className="m-1 btn-cancelar-form"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="Cancelar"
                        onClick={redirectPage}
                    >Cancelar
                    </button>

                    {!esUltimaSeccion ?
                        <button
                            type="button"
                            className={`m-1 btn-avanzar btn-avanzar-${seccionActiva}`}
                            onClick={irSeccionSiguiente}
                        >Siguiente <ChevronRight className="ml-1" />
                        </button>
                        :
                        <button
                            type="button"
                            className={`m-1 btn-avanzar btn-avanzar-${seccionActiva}`}
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title="Registrar proveedor"
                            disabled={deactivate}
                            onClick={validateBankDetails}
                        >{status ?
                            <span>Guardando...</span>
                            : <span><Check className="mr-1" />Registrar</span>}
                        </button>
                    }
                </div>
            </Card.Footer>
        );
    }

    let mostrarListEmpresas = () => {
        if (errorEmpresas) {
            return (
                <div>Error: No se han podido cargar las empresas disponibles</div>
            );
        } else {
            const columns = [
                {
                    dataField: 'empresa',
                    filter: textFilter({
                        placeholder: 'Buscar empresa...',
                        className: "form-control-sm"
                    })
                }
            ];
            const selectRow = {
                mode: "checkbox",
                clickToSelect: true,
                style: { backgroundColor: '#4FD290' },
                selected: idEmpresasSeleccionadas,
                onSelect: (row, isSelect, rowIndex, e) => {
                    if (isSelect && enterpriseValidation(row.empresa)) {
                        isSelect = false;
                        enterpriseSelected(row.empresa);
                    }

                    if (isSelect) {
                        setIdEmpresasSeleccionadas([...idEmpresasSeleccionadas, row.empresaId]);
                        setEmpresasSeleccionadas([...empresasSeleccionadas, row]);
                    } else {
                        let eliminarIdEmpresaSeleccionada = idEmpresasSeleccionadas.filter(x => x !== row.empresaId);
                        setIdEmpresasSeleccionadas(eliminarIdEmpresaSeleccionada);
                        let eliminarEmpresaSeleccionada = empresasSeleccionadas.filter(x => x !== row);
                        setEmpresasSeleccionadas(eliminarEmpresaSeleccionada);
                    }
                },
                onSelectAll: (isSelect, rows, e) => {
                    const ids = rows.map(row => row.empresaId);
                    const empresasS = rows.map(row => row);
                    if (isSelect) {
                        setIdEmpresasSeleccionadas(ids);
                        setEmpresasSeleccionadas(empresasS);
                    } else {
                        setIdEmpresasSeleccionadas([]);
                        setEmpresasSeleccionadas([]);
                    }
                },
            };

            function indication() {
                return empresasDisponibles.length ? "La búsqueda no coincide con ningún criterio" : "No hay registros que mostrar";
            }

            const customTotal = (from, to, size) => (
                <span className="react-bootstrap-table-pagination-total">
                    Mostrando {from} - {to} de {size}
                </span>
            );

            const options = {
                custom: true,
                sizePerPage: 10,
                totalSize: empresasDisponibles.length,
                paginationTotalRenderer: customTotal
            }

            return <PaginationProvider pagination={paginationFactory(options)}>
                {({ paginationProps, paginationTableProps }) => (
                    <div>
                        <Form.Row className="p-2">
                            {<div className="d-flex flex-row">
                                <Form.Label column>Mostrar</Form.Label>
                                <Col>
                                    <SizePerPageDropdownStandalone btnContextual {...paginationProps} />
                                </Col>
                            </div>}
                            <div className="flex-row">
                                <Col>
                                    <PaginationTotalStandalone {...paginationProps} />
                                </Col>
                            </div>
                            <div className="d-flex ml-auto flex-row-reverse">
                                <Col>
                                    <PaginationListStandalone {...paginationProps} />
                                </Col>
                                <Form.Label column>Página</Form.Label>
                            </div>
                        </Form.Row>
                        <div className="table-responsive table-sm panel-empresas p-2">
                            <BootstrapTable
                                id="id"
                                keyField="empresaId"
                                data={empresasDisponibles}
                                columns={columns}
                                selectRow={selectRow}
                                filter={filterFactory()}
                                bordered={false}
                                striped
                                hover
                                condensed
                                noDataIndication={indication}
                                {...paginationTableProps}
                            />
                        </div>
                    </div>
                )}
            </PaginationProvider>
        }
    }

    return (
        <section className="pagina-nuevo-proveedor">
            <Form id="formNuevoProveedor" className="form-proveedor" onSubmit={(e) => e.preventDefault()}>
                <div className="p-2">
                    <output id="listResponse"></output>
                </div>

                <Card className="card-nuevo-proveedor">
                    <Card.Header className="p-0 border-0 bg-transparent">
                        {renderStepper()}
                    </Card.Header>

                    <Card.Body className="seccion-nuevo-proveedor">
                        {seccionActiva === 'general' &&
                            <fieldset className="panel-seccion panel-general">
                                <Form.Row >
                                    {<Form.Group as={Col} sm={12} md={12} lg={4} className="panel-empresas p-3">EMPRESA
                                        {request ? "Cargando..." : mostrarListEmpresas()}
                                    </Form.Group>}
                                    <Form.Group as={Col} sm={8} md={8} lg={8}>
                                        <Form.Row>
                                            <Form.Group as={Col}>
                                                <Form.Label>RFC</Form.Label>
                                                <InputGroup size="sm">
                                                    <Form.Control type="text" required
                                                        className="form-control form-control-sm"
                                                        placeholder="Ingrese rfc"
                                                        value={proveedorRfc}
                                                        onChange={handleProveedorRfcChange}
                                                    ></Form.Control>
                                                    <button
                                                        type="button"
                                                        className="m-1 button-default-subir-archivo"
                                                        data-toggle="tooltip"
                                                        data-placement="bottom"
                                                        title="Buscar"
                                                        onClick={searchSupplier}
                                                    >
                                                        <FontAwesomeIcon icon={faMagnifyingGlass} />
                                                    </button>
                                                </InputGroup>
                                                {
                                                    errorMessage.length > 0 ?
                                                        <p>{errorMessage}</p> : ''
                                                }
                                            </Form.Group>
                                        </Form.Row>
                                        <Form.Row>
                                            <Form.Group as={Col}>
                                                <Form.Label>Identificador</Form.Label>
                                                <Form.Control type="text" disabled
                                                    className="form-control form-control-sm"
                                                    placeholder="Este campo se generará en automático"
                                                    value={idProveedor}
                                                ></Form.Control>
                                            </Form.Group>
                                            <Form.Group as={Col}>
                                                <Form.Label>Razón social</Form.Label>
                                                <Form.Control type="text"
                                                    required className="form-control form-control-sm"
                                                    placeholder="Ingrese razón social"
                                                    value={razonSocial}
                                                    onChange={handleRazonSocialChange}>
                                                </Form.Control>
                                            </Form.Group>
                                        </Form.Row>
                                        <Form.Row>
                                            <Form.Group as={Col}>
                                                <Form.Label>Nombre comercial</Form.Label>
                                                <Form.Control type="text" required
                                                    className="form-control form-control-sm"
                                                    placeholder="Ingrese nombre comercial"
                                                    value={nombreComercial}
                                                    onChange={handleNombreComercialChange}>
                                                </Form.Control>
                                            </Form.Group>
                                            <Form.Group as={Col}>
                                                <Form.Label>Giro</Form.Label>
                                                <Form.Control type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Ingrese giro"
                                                    value={giro}
                                                    onChange={handleGiroChange}>
                                                </Form.Control>
                                            </Form.Group>
                                        </Form.Row>
                                        <Form.Row>
                                            <Form.Group as={Col}>
                                                <Form.Label>Correo electrónico</Form.Label>
                                                <Form.Control type="text" required
                                                    className="form-control form-control-sm"
                                                    placeholder="Ingrese correo electrónico"
                                                    value={correoElectronico}
                                                    onChange={handleCorreoElectronicoChange}>
                                                </Form.Control>
                                            </Form.Group>
                                            <Form.Group as={Col}>
                                                <Form.Label>Teléfono</Form.Label>
                                                <Form.Control type="text" required
                                                    className="form-control form-control-sm"
                                                    placeholder="Ingrese teléfono"
                                                    value={telefono}
                                                    onChange={handleTelefonoChange}>
                                                </Form.Control>
                                            </Form.Group>
                                        </Form.Row>
                                    </Form.Group>
                                </Form.Row>
                            </fieldset>
                        }

                        {seccionActiva === 'direccion' &&
                            <fieldset className="panel-seccion panel-direccion">
                                <Form.Row as={Col}>
                                    <Form.Group as={Col}>
                                        <Form.Label>Tipo de dirección</Form.Label>
                                        <Form.Control as="select"
                                            placeholder="Elige un tipo de dirección"
                                            className="form-control form-control-sm"
                                            value={tipo}
                                            onChange={handleTipoChange}>
                                            <option value="">Elige una opción</option>
                                            <option value="Fiscal">Dirección Fiscal</option>
                                            <option value="Sucursal">Dirección de Sucursal</option>
                                            <option value="Bodega">Dirección de Bodega</option>
                                        </Form.Control>
                                    </Form.Group>
                                    <Form.Group as={Col}>
                                        <Form.Label>Calle</Form.Label>
                                        <Form.Control type="text" required
                                            placeholder="Ingrese calle"
                                            className="form-control form-control-sm"
                                            value={calle}
                                            onChange={handleCalleChange}>
                                        </Form.Control>
                                    </Form.Group>
                                </Form.Row>
                                <Form.Row as={Col}>
                                    <Form.Group as={Col}>
                                        <Form.Label>No. Exterior</Form.Label>
                                        <Form.Control type="text" required
                                            placeholder="Ingrese no. ext."
                                            className="form-control form-control-sm"
                                            value={numeroExterior}
                                            onChange={handleNumeroExteriorChange}>
                                        </Form.Control>
                                    </Form.Group>
                                    <Form.Group as={Col}>
                                        <Form.Label>No. Interior</Form.Label>
                                        <Form.Control type="text"
                                            placeholder="Ingrese no. int."
                                            className="form-control form-control-sm"
                                            value={numeroInterior}
                                            onChange={handleNumeroInteriorChange}>
                                        </Form.Control>
                                    </Form.Group>
                                </Form.Row>
                                <Form.Row as={Col} >
                                    <Form.Group as={Col}>
                                        <Form.Label>Código postal</Form.Label>
                                        <InputGroup size="sm">
                                            <Form.Control type="text" required
                                                placeholder="Ingrese cp"
                                                className="form-control form-control-sm"
                                                value={codigoPostal}
                                                onKeyPress={handleKeyPress}
                                                onChange={handleCodigoPostalChange}>
                                            </Form.Control>

                                            <button
                                                type="button"
                                                className="m-1 button-default-subir-archivo"
                                                data-toggle="tooltip"
                                                data-placement="bottom"
                                                title="Buscar"
                                                onClick={searchCP}
                                            >
                                                <FontAwesomeIcon icon={faMagnifyingGlass} />
                                            </button>
                                        </InputGroup>
                                        {
                                            errorCPMessage.length > 0 ?
                                                <p>{errorCPMessage}</p> : ''
                                        }
                                    </Form.Group>
                                    <Form.Group as={Col}>
                                        <Form.Label>Ciudad</Form.Label>
                                        <Form.Control type="text" required
                                            placeholder="Ingrese ciudad"
                                            className="form-control form-control-sm"
                                            value={ciudad}
                                            onChange={handleCiudadChange}>
                                        </Form.Control>
                                    </Form.Group>
                                </Form.Row>
                                <Form.Row as={Col}>
                                    <Form.Group as={Col}>
                                        <Form.Label>Municipio</Form.Label>
                                        <Form.Control type="text" required
                                            placeholder="Ingrese municipio"
                                            className="form-control form-control-sm"
                                            value={municipio}
                                            onChange={handleMunicipioChange}>
                                        </Form.Control>
                                    </Form.Group>
                                    <Form.Group as={Col}>
                                        <Form.Label>Colonia</Form.Label>
                                        {
                                            !isSearch ? <Form.Control type="text" required
                                                placeholder="Ingrese colonia"
                                                className="form-control form-control-sm"
                                                value={colonia}
                                                onChange={handlerColoniaChange}>
                                            </Form.Control>
                                                :
                                                <Form.Control as="select"
                                                    placeholder="Elige la colonia"
                                                    className="form-control form-control-sm"
                                                    value={colonia}
                                                    onChange={handlerColoniaChange}>
                                                    <option value="">Elige una opción</option>
                                                    {colonias.map(el => (
                                                        <option key={el.clave} value={el.descripcion}>{el.descripcion}</option>
                                                    ))}
                                                </Form.Control>
                                        }
                                    </Form.Group>
                                </Form.Row>
                                <Form.Row as={Col}>
                                    <Form.Group as={Col}>
                                        <Form.Label>Estado</Form.Label>
                                        <Form.Control type="text" required
                                            placeholder="Ingrese estado"
                                            className="form-control form-control-sm"
                                            value={estado}
                                            onChange={handleEstadoChange}>
                                        </Form.Control>
                                    </Form.Group>
                                    <Form.Group as={Col}>
                                        <Form.Label>País</Form.Label>
                                        <Form.Control type="text" required
                                            placeholder="Ingrese país"
                                            className="form-control form-control-sm"
                                            value={pais}
                                            onChange={handlePaisChange}>
                                        </Form.Control>
                                    </Form.Group>
                                </Form.Row>
                            </fieldset>
                        }

                        {seccionActiva === 'bancarios' &&
                            <fieldset className="panel-seccion panel-bancarios">
                                <Form.Row as={Col}>
                                    <Form.Group as={Col}>
                                        <Form.Label>Banco</Form.Label>
                                        {
                                            !active ?
                                                <InputGroup size="sm">
                                                    <Form.Control type="text" required
                                                        placeholder="Ingrese banco"
                                                        className="form-control form-control-sm"
                                                        value={banco}
                                                        onChange={handleBancoChange}>
                                                    </Form.Control>
                                                    {
                                                        returnToActivate ? <button
                                                            type="button"
                                                            className="m-1 button-default-subir-archivo"
                                                            data-toggle="tooltip"
                                                            data-placement="bottom"
                                                            title="Buscar"
                                                            onClick={changeToSelect}
                                                        >
                                                            <FontAwesomeIcon icon={faRotateLeft} />
                                                        </button> : ''
                                                    }
                                                </InputGroup> :
                                                <Form.Control as="select"
                                                    placeholder="Elige una opción"
                                                    className="form-control form-control-sm"
                                                    onChange={setDataAccount}>
                                                    <option value={-1}>Elige una opción</option>
                                                    {dataBank.map(el => (
                                                        <option key={el.id} value={el.id}>{el.banco}</option>
                                                    ))}
                                                    <option value="otro">Otro</option>
                                                </Form.Control>
                                        }
                                    </Form.Group>
                                    <Form.Group as={Col}>
                                        <Form.Label>Comentario</Form.Label>
                                        <Form.Control type="text"
                                            placeholder="Ingrese notas adicionales"
                                            className="form-control form-control-sm"
                                            value={comentario}
                                            onChange={handleComentarioChange}>
                                        </Form.Control>
                                    </Form.Group>
                                </Form.Row>
                                <Form.Row as={Col}>
                                    <Form.Group as={Col}>
                                        <Form.Label>Cuenta</Form.Label>
                                        <NumberFormat
                                            format="#### #### #### #### #### ####"
                                            mask="_"
                                            className="form-control form-control-sm"
                                            placeholder="Ingrese número de cuenta"
                                            value={cuenta}
                                            onChange={handleCuentaChange}
                                        />
                                        <Form.Text muted>Hasta 24 dígitos </Form.Text>
                                    </Form.Group>
                                    <Form.Group as={Col}>
                                        <Form.Label>Cuenta CLABE</Form.Label>
                                        <NumberFormat
                                            format="#### #### #### #### ##"
                                            mask="_"
                                            className="form-control form-control-sm"
                                            placeholder="Ingrese cuenta clabe"
                                            value={cuentaClabe}
                                            onChange={handleCuentaClabeChange}
                                        />
                                        <Form.Text muted>18 dígitos </Form.Text>
                                    </Form.Group>
                                </Form.Row>
                                <Form.Row as={Col}>
                                    <Form.Group as={Col}>
                                        <Form.Label>Referencia</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Ingrese referencia"
                                            className="form-control form-control-sm"
                                            value={referencia}
                                            onChange={handleReferenciaChange}
                                        >
                                        </Form.Control>
                                    </Form.Group>
                                </Form.Row>
                            </fieldset>
                        }
                    </Card.Body>

                    {renderFooter()}
                </Card>
            </Form>
        </section >
    );
}

export default FormularioNuevoProveedor;